import React from "react";
import { Play, MapPin } from "lucide-react";

import heroImg from "../../../Images/hero-villa.jpg";
import cityImg from "../../../Images/city-skyline.jpg";
import interiorImg from "../../../Images/apartment-interior.jpg";
import towerImg from "../../../Images/property-tower.jpg";


// function WinnersUpcoming() {
//   const reels = [
//     { title: "Skyline Lofts", loc: "Gurgaon", img: towerImg },
//     { title: "Quartz Atelier", loc: "Lucknow", img: heroImg },
//     { title: "Aria Greens", loc: "Noida Ext.", img: interiorImg },
//     { title: "Lumen Heights", loc: "Dwarka", img: cityImg },
//   ];

//   return (
//     <section className="ws-upcoming">
//       {/* same JSX from original component */}
//     </section>
//   );
// }

// export default WinnersUpcoming;

export function WinnersUpcoming() {
  const reels = [
    { title: "Skyline Lofts", loc: "Gurgaon", img: towerImg },
    { title: "Quartz Atelier", loc: "Lucknow", img: heroImg },
    { title: "Aria Greens", loc: "Noida Ext.", img: interiorImg },
    { title: "Lumen Heights", loc: "Dwarka", img: cityImg },
    { title: "Casa Sereno", loc: "Kanpur", img: towerImg },
    { title: "Verde Court", loc: "Faridabad", img: heroImg },
    { title: "Solis Pavillion", loc: "South Delhi", img: interiorImg },
    { title: "Aurora Yards", loc: "Greater Noida", img: cityImg },
  ];

  return (
    <section className="ws-upcoming">
      <div className="ws-upcoming-head">
        <span className="ws-section-eyebrow">Future developments</span>
        <h2 className="ws-section-heading">Our upcoming projects.</h2>
      </div>
      <div className="ws-upcoming-grid">
        {reels.map((r, i) => (
          <article className="ws-reel" key={r.title + i}>
            <img src={r.img} alt={r.title} loading="lazy" width={400} height={620} />
            <span className="ws-reel-loc"><MapPin size={11} /> {r.loc}</span>
            <div className="ws-reel-play"><Play size={20} fill="currentColor" /></div>
            <div className="ws-reel-body">
              <h3>{r.title}</h3>
              <p>Launching 2026 · Reel preview</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}